import React from 'react'
import useDiscussion from './use-discussion'
import Participations from './participations'
import Participants from './participants'
import ParticipateInput from './participate-input'
import useRefreshDiscussions from './use-refresh-discussions'

const ParticipationsList = ({ discussionId }) => {
    const { discussion, isLoading, users } = useDiscussion({ discussionId })
    useRefreshDiscussions({ discussionId })

    if (isLoading) {
        return null
    }
    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            height: 'calc(100%)'
        }}>
            <div
                style={{
                    paddingLeft: '10px'
                }}
            >
                <h4>{discussion.topic}</h4>
            </div>
            <div
                style={{
                    borderBottom: '1px solid rgb(225, 225, 225)',
                    paddingLeft: '5px'
                }}
            >
                <Participants users={users} />
            </div>
            <div style={{ flexGrow: '1', minHeight: '0' }}>
                <Participations discussionId={discussionId} />
            </div>
            
            <div>
                <ParticipateInput discussionId={discussionId} />
            </div>
        </div>
    )
}

export default ParticipationsList
